import { z } from 'zod'
import { MeetingIdSchema } from '../meeting'
import { TeamIdSchema } from '../ids'
import { ConversationIdSchema } from '../conversation/model'
import { CalendarEventIdSchema } from '../calendar'
import { AreaIdSchema } from '../area'

const destinationFields = {
  date: z.iso.date().optional(),
  params: z.record(z.string(), z.string()).optional(),
}
export const NotificationDestinationTargetSchema = z.discriminatedUnion('kind', [
  z.object({ ...destinationFields, kind: z.literal('area'), id: AreaIdSchema }).strict(),
  z.object({ ...destinationFields, kind: z.literal('areaAccounts'), id: AreaIdSchema }).strict(),
  z.object({ ...destinationFields, kind: z.literal('appointment'), id: CalendarEventIdSchema }).strict(),
  z.object({ ...destinationFields, kind: z.literal('calendarDay'), date: destinationFields.date.unwrap() }).strict(),
  z.object({ ...destinationFields, kind: z.literal('meetingCheckIn'), id: MeetingIdSchema }).strict(),
  z.object({ ...destinationFields, kind: z.literal('team'), id: TeamIdSchema.optional() }).strict(),
  z.object({ ...destinationFields, kind: z.literal('areasList') }).strict(),
  z.object({ ...destinationFields, kind: z.literal('notifications') }).strict(),
  z.object({ ...destinationFields, kind: z.literal('conversation'), convoId: ConversationIdSchema }).strict(),
])
export type NotificationDestinationTarget = z.infer<typeof NotificationDestinationTargetSchema>
